export class devMode {
    _isEnabled: boolean = null;
    key: string;

    constructor(key: string) {
        this.key = key;
    }

    isEnabled() {
        return (this._isEnabled ??= this._getIsEnabled());
    }

    _getIsEnabled() {
        try {
            return localStorage.getItem(this.key) != null;
        } catch (e) {
            return false;
        }
    }

    setIsEnabled(value: boolean, reload: boolean = false) {
        this._isEnabled = !!value;

        if (value) {
            localStorage.setItem(this.key, "true");
        } else {
            localStorage.removeItem(this.key);
        }

        if (reload) {
            location.reload();
        }
    }
}
